<template>
    <nav class="nav-bar" :class="{visible: isNavVisible, expanded: isBurgerOpen}" >
        <div class="wrapper">
            <a class="nav-bar__company-name" href="#top" v-vk-scroll>TreeTopTrip</a>
            <ul class="uk-nav nav-bar__menu menu-resized" :class="{enableNav: isNavVisible}" uk-scrollspy-nav="closest: li; scroll: true;">
                <li><a href="#services">SERVICES</a></li>
                <li><a href="#partners">PARTNERS</a></li>
                <li><a href="#technologies">TECHNOLOGIES</a></li>
                <li><a href="#contact">CONTACT</a></li>
            </ul>
            <div class="nav-bar__burger-menu burger-resized">
                <ul class="uk-nav nav-bar__burger-menu--list" :class="{burgerVisible: !isBurgerOpen}" uk-scrollspy-nav="closest: li; scroll: true;">
                    <li><a @click="isBurgerOpen = !isBurgerOpen" href="#services">SERVICES</a></li>
                    <li><a @click="isBurgerOpen = !isBurgerOpen" href="#partners">PARTNERS</a></li>
                    <li><a @click="isBurgerOpen = !isBurgerOpen" href="#technologies">TECHNOLOGIES</a></li>
                    <li><a @click="isBurgerOpen = !isBurgerOpen" href="#contact">CONTACT</a></li>
                </ul>
                <vk-navbar-toggle class="nav-bar__burger-menu--burger-ico" @click="isBurgerOpen = !isBurgerOpen" :class="{burgerVisible: isBurgerOpen}"></vk-navbar-toggle>
                <vk-icon class="nav-bar__burger-menu--burger-close" icon="close" ratio="1.5" @click="isBurgerOpen = !isBurgerOpen" :class="{burgerVisible: !isBurgerOpen}"></vk-icon>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'nav-bar',

        data() {
                return {
                isNavVisible: false,
                windowTop: 0,
                windowHeight: 0,
                isBurgerOpen: false
            }
        },

        watch: {
            windowTop() {
                this.controlNavVisibility();
            }
        },

        mounted() {
            window.addEventListener('scroll', this.positionFromTop);
            window.addEventListener('resize', this.getWindowSize);
            this.getWindowSize();
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.positionFromTop);
            window.removeEventListener('resize', this.getWindowSize);
        },
        methods: {
            positionFromTop(e) {
                this.windowTop = window.top.scrollY;
            },
            getWindowSize() {
                this.windowHeight = window.innerHeight;

            },
            controlNavVisibility(){
                if(this.windowTop >= this.windowHeight){
                    this.isNavVisible = true;
                } else {
                    this.isBurgerOpen = false;
                    this.isNavVisible = false;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .nav-bar.visible {
        z-index: 1000;
        top:0;
    }

    .nav-bar__menu.enableNav {
        visibility: visible ;
    }

    .nav-bar {
        font-family: Raleway;
		font-weight: 600;
        width: 100%;
        height: 90px;
        background-color: black;
        position: fixed;
        transition: linear .2s;
        z-index: 0;
        top: -90px;

        .wrapper {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        
        &__company-name {
            margin: 0;
            font-family: dubiel;
            font-size: 2.8rem;
            color: white;
            font-weight: 300;

            &:hover {
                text-decoration: none;
            }
        }

        &__menu {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 100%;
            visibility: hidden;

            li {
                font-size: 14px;
                margin: 20px;
                letter-spacing: 3px;
                a {
                    color: white;

                    &:hover {
                        color: #ff5400;
                    }
                }
            }

            .uk-active {
                a {
                    color: #ff5400;
                }
            }
        }


        &__burger-menu {
            display: flex;
            align-items: center;
            transition: ease-in-out 2s;

            &--list {
                display: initial;

                li {
                    font-size: 10px;
                    margin: 10px 20px;
                    letter-spacing: 3px;
                    text-align: right;

                    a {
                        color: white;

                        &:hover {
                            color: #ff5400;
                        }
                    }
                }
            }

            &--burger-ico {
                color: white;
                display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
                display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
                display: -ms-flexbox;      /* TWEENER - IE 10 */
                display: -webkit-flex;     /* NEW - Chrome */
                display:flex;

                &:hover {
                    color: #ff5400;
                }
            }


            &--burger-close {
                color: white;
                cursor: pointer;
                padding: 0 10px;
                display: flex;


                &:hover {
                    color: #ff5400;
                }
            }
        }

        .burger-resized {
            display: none;
        }
    }

    .nav-bar.expanded {
        height: 160px;
    }

    .burgerVisible {
        display: none;
    }

    @media all and (max-width: 1200px) {
        .nav-bar {
            &__menu {
                li:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }

    @media all and (max-width: 830px) {
        .nav-bar {
            height: 60px;

            &__company-name {
                font-size: 1.8rem;
            }

            &__menu {
                li {
                    font-size: 10px;
                    margin: 15px;
                }
            }
        }
    }

    @media all and (max-width: 650px) {
        .nav-bar {
            .burger-resized {
                display: flex;
            }
            .menu-resized {
                display: none;
            }
        }
    }
</style>